// STATE 
export const showEditTabNameForm = '';

// REDUCER
export const ShowEditTabNameFormReducer = (state, action) => {
    switch (action.type) {
        case 'openEditTabNameForm':
            return true
        case 'closeEditTabNameForm':
            return false
        default:
            return false
    }
}
